module.exports = __webpack_public_path__ + "static/media/logo-cydocs-blanco.7c1236ec.png";